import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  modalGrid: {
    dialogOptions: {
      type: 'panel'
    }
  }
} satisfies RecursivePartial<ProductConfig['accordions']>
